import { DocumentDigital } from 'shell/view-models/act-form';
import { DocumentANSC } from 'shell/models/person/document-ANSC';

export const transformDocumentDigital = (
  values: DocumentDigital | undefined | null
): DocumentANSC | undefined => {
  if (!(values?.year || values?.municipality || values?.documentDate || values?.idAnsc)) {
    // se non ci sono dati
    return undefined;
  }

  const returnData: DocumentANSC | undefined = values
    ? {
        idANSC: values.idAnsc || undefined,
        anno: values?.year || undefined,
        numeroComunale: values?.numberMunicipality || undefined,
        comuneRegistrazione: values?.municipality
          ? {
              codiceIstat: values?.municipality?.id || undefined,
              // descrizioneLocalita: values?.location || undefined,
              nomeComune: values?.municipality?.description || undefined,
              siglaProvinciaIstat: values?.municipality?.province || undefined,
            }
          : undefined,
        dataFormazioneAtto: values?.documentDate?.toFormat('yyyy-MM-dd') || undefined,
        trascritto: values?.transcript ? '1' : '0',
      }
    : undefined;

  return returnData;
};
